<div class="relative">
  <button
    (click)="toggle()"
    class="flex items-center justify-center rounded-lg bg-white dark:bg-night-900 shadow-lg w-14 h-14 cursor-pointer overflow-hidden">
    @if (selectedCompany()?.managementFile?.blobUrl) {
      <img
        [src]="selectedCompany()?.managementFile?.blobUrl"
        [alt]="selectedCompany()?.tradeName"
        class="w-full h-full object-contain" />
    } @else {
      <svg
        width="24"
        height="24"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.28 26.4L1.88 0L0 1.88L3.08 4.97333V22.5333C3.08 24 4.28 25.2 5.74667 25.2H23.3067L26.3867 28.28L28.28 26.4ZM5.74667 21.2L10.4133 15.2L13.7467 19.2133L15.3067 17.2L19.3067 21.2H5.74667ZM27.08 21.4267L6.85333 1.2H24.4133C25.88 1.2 27.08 2.4 27.08 3.86667V21.4267Z"
          fill="#E7E7E7" />
      </svg>
    }
  </button>

  @if (isOpen()) {
    <div
      class="absolute right-0 top-16 z-50 w-72 bg-white dark:bg-night-900 rounded-xl shadow-xl dark:shadow-none border border-neutral-100 dark:border-night-700 p-3 flex flex-col gap-1">
      <span class="text-neutral-400 text-base font-normal pb-2">Empresas</span>

      @if (selectedCompany(); as selected) {
        <div class="flex items-center gap-2 py-1">
          <div
            class="w-8 h-8 rounded-lg overflow-hidden flex-shrink-0 flex items-center justify-center bg-neutral-50 dark:bg-night-800">
            @if (selected.managementFile?.blobUrl) {
              <img
                [src]="selected.managementFile?.blobUrl"
                [alt]="selected.tradeName"
                class="w-8 h-8 object-contain" />
            }
          </div>
          <span
            class="flex-1 text-neutral-700 dark:text-night-300 text-sm font-normal leading-5 line-clamp-1">
            {{ selected.tradeName }}
          </span>
          <app-icon-wrapper
            [color]="'currentColor'"
            [size]="'small-medium'"
            class="text-primary-600 dark:text-primary-400"
            icon="check-circle" />
        </div>
      }

      <div class="py-2">
        <div
          class="flex items-center gap-2 p-3 bg-white dark:bg-night-800 rounded-md border border-neutral-200 dark:border-night-700">
          <app-icon-wrapper
            [color]="'#B0B0B0'"
            [size]="'small-medium'"
            icon="search" />
          <input
            type="text"
            [ngModel]="searchTerm()"
            (ngModelChange)="onSearch($event)"
            placeholder="Buscar"
            class="flex-1 text-sm font-normal text-neutral-700 dark:text-night-300 placeholder-neutral-400 outline-none bg-transparent" />
        </div>
      </div>

      <div class="flex flex-col max-h-52 overflow-y-auto">
        @if (hasOtherCompanies()) {
          @for (company of filteredCompanies(); track company.refId) {
            @if (!isSelected(company)) {
              <button
                (click)="selectCompany(company)"
                class="flex items-center gap-2 py-1 cursor-pointer hover:bg-neutral-50 dark:hover:bg-night-800 rounded-md transition-colors">
                <div
                  class="w-8 h-8 rounded-lg border border-neutral-100 dark:border-night-700 overflow-hidden flex-shrink-0 flex items-center justify-center bg-white dark:bg-night-800">
                  @if (
                    company.managementFile?.blobUrl &&
                    company.managementFile?.state !== 'DELETED'
                  ) {
                    <img
                      [src]="company.managementFile?.blobUrl"
                      [alt]="company.tradeName"
                      class="w-8 h-8 object-contain" />
                  } @else {
                    <span class="text-neutral-300 text-xs">—</span>
                  }
                </div>
                <span
                  class="flex-1 text-left text-neutral-400 text-sm font-normal leading-5 line-clamp-1">
                  {{ company.tradeName }}
                </span>
              </button>
            }
          }
        } @else {
          <div class="flex items-center justify-center py-4">
            <span class="text-neutral-400 text-sm text-center">No tienes más empresas asignadas.</span>
          </div>
        }
      </div>
    </div>
  }
</div>
